<template>
  <div v-if="enabled" class="processing-demo-banner neue" role="status" data-testid="demo-banner">
    <strong>{{ $t('components.service.ZentrolinkFooter.1') }}</strong>
    <span>{{ $t('components.service.ZentrolinkFooter.2') }}</span>
  </div>
</template>

<script>
export default {
  name: 'DemoBanner',
  computed: {
    enabled() {
      return this.$store.state.runtimeEnvironment?.testEnvironmentNotice?.enabled === true;
    }
  }
};
</script>

<style lang="scss" scoped>
.processing-demo-banner {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px 8px;
  padding: 12px 16px;
  color: #5c3100;
  background: #fff3df;
  border-bottom: 1px solid #f0c98d;
  font-size: 14px;
  line-height: 20px;
  overflow-wrap: anywhere;
  text-align: center;
}
</style>
